import { queryOptions } from "@/Services";
import { Button, Group, Popover, SegmentedControl, Select, Skeleton, Stack } from "@mantine/core"
import { IconFilter2 } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import classes from "./TemplateFilter.module.css";

export const TemplateFilter = ({ params,setParams, ...props }) => {

    const { t } = useTranslation();

    const { data: industryData, isLoading: isLoadingIndustry } = queryOptions({ type: 'industry' });
    const { data: occasionData, isLoading: isLoadingOccasion } = queryOptions({ type: 'occasion' });
    const { data: formatData, isLoading: isLoadingFormat } = queryOptions({ type: 'format' });
    const { data: langData, isLoading: isLoadingLang } = queryOptions({ type: 'language' });

    const renderSelects = (width) => (
        <>
            {
                isLoadingOccasion ? <Skeleton  h={36} w={width} radius="md"/> : (

                    <Select
                        radius="md"
                        w={width}
                        classNames={{ input: classes.input, section: classes.section, option: classes.option }}
                        comboboxProps={{ width: 'target' }}
                        placeholder={t('common.industry')}
                        variant="filled"
                        defaultValue={route().params?.categoryType === 'industry' ? route().params.categoryId ?? '' : ''}
                        data={industryData}
                        clearable
                        onChange={(value) => setParams({ industry_id: value })} />
                )
            }
            {
                isLoadingIndustry ? <Skeleton  h={36} w={width} radius="md"/> : (
                    <Select
                        radius="md"
                        w={width}
                        classNames={{ input: classes.input, section: classes.section, option: classes.option }}
                        comboboxProps={{ width: 'target' }}
                        placeholder={t('common.occasion')}
                        variant="filled"
                        defaultValue={route().params?.categoryType === 'occasion' ? route().params.categoryId ?? '' : ''}
                        clearable
                        data={occasionData}
                        onChange={(value) => setParams({ occasion_id: value })} />
                )
            }
            {
                isLoadingLang ? <Skeleton  h={36} w={width} radius="md"/> : (
                    <Select
                        radius="md"
                        w={width}
                        classNames={{ input: classes.input, section: classes.section, option: classes.option }}
                        comboboxProps={{ width: 'target' }}
                        placeholder={t('common.language')}
                        variant="filled"
                        clearable
                        data={langData}
                        onChange={(value) => setParams({ lang: value })} />
                )
            }
        </>
    );

    const renderFormats = (segmentedProps) => (
        isLoadingFormat ? <Skeleton  h={36} w={350} maw="100%" radius="md"/> : (
            <SegmentedControl
                radius="md"
                value={params?.banner_format_id ?? ""}
                data={
                [
                    { label: t('common.all'), value: '' },
                    ...formatData?.filter(item => item.value !== '3')?.map(item => ({...item, label: item.label.split(" (")[0]}))
                ]}
                onChange={(value) => setParams({ banner_format_id: value })}
                {...segmentedProps}/>
        )
    );

    return (
        <>
            <Group my="md" justify="space-between" visibleFrom="sm">
                <Group>
                    {renderSelects(230)}
                </Group>

                {renderFormats()}
            </Group>

            {/* AD-230: a phone has no room for the filters, so they open from a button. */}
            <Group my="md" justify="flex-end" hiddenFrom="sm">
                <Popover position="bottom-end" width={280} shadow="md" radius="md" keepMounted>
                    <Popover.Target>
                        <Button variant="default" radius={8} fw={500} leftSection={<IconFilter2 size={14} />}>
                            {t('templates.filterTemplate')}
                        </Button>
                    </Popover.Target>
                    <Popover.Dropdown>
                        <Stack gap="sm">
                            {renderSelects('100%')}
                            {renderFormats({ orientation: 'vertical', fullWidth: true })}
                        </Stack>
                    </Popover.Dropdown>
                </Popover>
            </Group>
        </>
    )
}
